/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/order */
import './index.css';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { installCspViolationCapture } from '#services/cspViolations';

// Capture CSP violations app-wide so silent blocks (e.g. a Stripe endpoint
// missing from connect-src that stalls confirmPayment) are visible in Rollbar.
installCspViolationCapture();

const CHUNK_RELOAD_KEY = 'chunk_reload';

function handleChunkLoadError() {
  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
}

window.addEventListener('error', (e) => {
  if (/Loading.*chunk.*failed|ChunkLoadError/.test(e.message)) {
    handleChunkLoadError();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || '';
  if (/Loading.*chunk.*failed|ChunkLoadError/.test(msg)) {
    handleChunkLoadError();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
